import { useEffect } from "react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { BmiCalculator } from "@/components/site/BmiCalculator";
import { Booking } from "@/components/site/Booking";
import { ClinicInfo } from "@/components/site/ClinicInfo";
import { Faq } from "@/components/site/Faq";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  useEffect(() => {
    if (window.location.hash) document.querySelector(window.location.hash)?.scrollIntoView();
  }, []);
  return (
    <div className="min-h-screen bg-background" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <BmiCalculator />
        <Booking />
        <ClinicInfo />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}
